<template>
  <div>
    <Icon
      type="xmark"
      fa-style="fas"
      class="text-xl text-primary"
    />
  </div>
</template>

<script setup lang="ts">
import Icon from '@/components/icon/Icon.vue'

defineProps({})
</script>

<style></style>
